import styled from "styled-components";
//utils
import { CurrencyFormat } from 'utils/CurrencyFormat';
interface ITotal {
    name: string,
    value: string, 
}
export default function TotalItems({name, value}:ITotal) {
    return (
        <Container>
            <Title>{name}</Title>
            <H3>{CurrencyFormat(parseFloat(value || '0'))}</H3>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;

    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    border-radius: 8px;
    padding: 8px 12px;

    width: 100%;
`;

const Title = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

const H3 = styled.p`
    font-size: 32px;
    font-weight: 500;
`;